export const locale = {
  lang: "vi",
  data: {
    MENU: {
      HOME: "Trang chủ",
      SAMPLE: "Mẫu",
      INFRA_OPS: "Quản trị hạ tầng"
    }
  }
};
